<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span> {{ $t('configuration.resources') }} </span></li>
				</ul>
			</div>
		</div>


		<div class="toolbar">
			<button id="resources_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="resources_table_toolbar_load" :title="$t('load.configuration.resource')">
				<span uk-icon="refresh"></span>
				<span class="title">{{ $t('load.configuration.resource') }}</span>
			</button>
			<button id="resources_table_toolbar_remove" :title="$t('remove.configuration.resource')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('remove.configuration.resource') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="table_search collapse">
					<div class="row">
						<h4 class="uk-text-normal search_title">
							{{ $t('filter') }}
							<div class="uk-float-right section_settings">
								<span class="uk-collapse" uk-icon="icon: chevron-up; ratio: .8"></span>
							</div>
						</h4>
					</div>
					<div class="row">
						<div id="search-controls">
							<div id="types" class="multicheckbox-filter col-sm-2">
								<label>
									{{ $t('configuration.resource.type') }}
								</label><br>
								<div tabindex="0" class="attribute-editor mcb-drop-down-wrapper">
									<div class="mcb-drop-down-btn fa fa-list-ul"></div>
									<div class="value-list"></div>
								</div>
								<div class="mcb-item-list">
									<div class="mcb-controls">
										<div class="mcb-clear blank" tabindex="0"></div>
										<input class="mcb-search " type="text">
										<button class="button_reset fa fa-times" tabindex="-1"></button>
									</div>
									<ul class="checkbox-list mcb-filter-list">
										<li><input class="attribute-editor bg-editor" type="checkbox" value="IMAGE">
											{{ $t('configuration.resource.type.image') }}
										</li>
										<li><input class="attribute-editor bg-editor" type="checkbox" value="XSLT">
											{{ $t('configuration.resource.type.xslt') }}
										</li>
										<li><input class="attribute-editor bg-editor" type="checkbox" value="EXCEL">
											{{ $t('configuration.resource.type.excel') }}
										</li>
										<li><input class="attribute-editor bg-editor" type="checkbox" value="XML">
											{{ $t('configuration.resource.type.xml') }}
										</li>
										<li><input class="attribute-editor bg-editor" type="checkbox" value="CSV">
											{{ $t('configuration.resource.type.csv') }}
										</li>
										<li><input class="attribute-editor bg-editor" type="checkbox" value="ZIP">
											{{ $t('configuration.resource.type.zip') }}
										</li>
									</ul>
									<ul class="checkbox-sublist mcb-filter-list"></ul>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="search_button">
							<button id="search" class="uk-button uk-button-primary uk-button-small">
								{{ $t('search') }}
							</button>
							<button id="search-clear" class="uk-button uk-button-default uk-button-small">
								{{ $t('clear.filters') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">
					{{ $t('edit.configuration.resource') }}
				</a></li>
				<li><a tabindex="-1">
					{{ $t('remove.configuration.resource') }}
				</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { downloadManager } from 'utils/download'
import { USER_CONFIG } from 'actions/user'
import { MigrationResourceManager } from '@/core/migration/MigrationResourceManager'
import { getFormattedDateTime, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'
import { resizeTableHeight, Table } from '@/core/support_gui_components/table/table'
import '@/core/input_controls/fileUploader/fileUploader'

export default {
	name: 'MigrationResources',
	metaInfo () {
		return {
			title: this.$t('configuration.resources')
		}
	},
	props: [
		'global'
	],
	mounted () {
		let vm = this
		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'configuration.resource.name',
				'columnName': 'name_link',
				'attribute': 'name'
			},
			{
				'title': 'configuration.resource.date.create',
				'columnName': 'dateCreate',
				'attribute': 'date_create'
			},
			{
				'title': 'configuration.resource.type',
				'columnName': 'type',
				'attribute': 'type'
			},
			{
				'title': 'configuration.resource.comment',
				'columnName': 'comment',
				'attribute': 'comment'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' },
			'types': { 'type': 'L' }
		}
		window.downloadManager = downloadManager

		var companyId = this.global ? null : this.$store.getters.getProfile.companyId
		window.manager = new MigrationResourceManager(companyId)
		let tableName = companyId ? 'companyMigrationResourcesTable' : 'globalMigrationResourcesTable'

		this.$store.dispatch(USER_CONFIG, tableName + '.tableState')
			.then((config) => {
				window.table = new Table(tableName, {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						frozenFirstColumn: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								manager.initMigrationResourceManager('edit', item, attribute, table)
							},
							2: function (item) {
								manager.initRemoveMigrationResource(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							value['dateCreate'] = getFormattedDateTime(new Date(value['dateCreate']))

							var dataCategory = (companyId == null) ? 'global' : 'company'
							var type = value['type'].toLowerCase()
							var name = value['name']
							var link = '/' + dataCategory + '/migration-resources/' + type

							value['name_link'] = '<a onclick="downloadManager(\'' + link + '\',\'' + name + '\')">' + name + '</a>'
						})
					})
				table.setSavedState(config)
				table.setDataUrl(manager.formatUrl('load'))
				table.setDataIDsUrl(manager.formatUrl('ids'))
				table.setDataSortUrl(manager.formatUrl('sort'))
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG ' + tableName, error)
			})

		// toolbar buttons
		$('#resources_table_toolbar_add').click(function () {
			manager.initUploadMigrationResource(table)
		})
		$('#resources_table_toolbar_load').click(function () {
			manager.loadData(table)
		})
		$('#resources_table_toolbar_remove').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert(this.$t('no.selected.resources'), 'warning')
			} else {
				manager.initMultipleRemoveMigrationResource(ids, table)
			}
		})

		$(":file").filestyle({buttonText: this.$t('choose.file') });

		$(window).resize(function() {
			resizeTableHeight();
			table.frozenTableElements.setFrozenHeaderCellsWidth();
			table.frozenTableElements.setFrozenColumnCellsHeight();
		});
	}
}
</script>

<style scoped>

</style>
